import styled from '@emotion/styled';
import { useContext } from 'react';
import { Link } from 'react-router';

import { ApplicationContext } from '../../../../../shared/source/context/context';

import type { FunctionComponent } from 'react';

const LogoImage = styled.img({
    width: '100px',
});

export const CompanyLogoV2: FunctionComponent = () => {
    const { applicationState } = useContext(ApplicationContext);
    const companyLogoUrl = applicationState.customization.get('uiConfiguration').get('assets').get('companyLogoUrl');

    if (companyLogoUrl.isJust) {
        return (
            <Link to="/">
                <LogoImage alt="Company logo" src={companyLogoUrl.value.href} />
            </Link>
        );
    }

    return null;
};
